import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../components/LanguageContext";
import "./Footer.css";

function Footer({ openModal }) {
  const { language } = useLanguage();

  const content = {
    en: {
      company: "Sparkles Laundry",
      tagline: "Professional Cleaning Services",
      services: "Services",
      contact: "Contact",
      address: "Jeddah, Saudi Arabia",
      email: "SparklesLaundry@gmail.com",
      phone: "+966560308877",
      servicesList: [
        "General Cleaning",
        "Upholstery Care",
        "Facade Cleaning",
        "Sanitization",
      ],
      social: "Follow Us",
      copyright: `© ${new Date().getFullYear()} All rights reserved`,
      author: "Eng. Mishari Dajam",
      portfolio: "Portfolio Project",
    },
    ar: {
      company: "مغاسل بريق الأساس",
      tagline: "خدمات تنظيف احترافية",
      services: "الخدمات",
      contact: "تواصل معنا",
      address: "جدة، المملكة العربية السعودية",
      email: "SparklesLaundry@gmail.com",
      phone: "+966560308877",
      servicesList: [
        "تنظيف عام",
        "عناية بالمفروشات",
        "تنظيف الواجهات",
        "التعقيم والتعطير",
      ],
      social: "تابعنا",
      copyright: `© ${new Date().getFullYear()} جميع الحقوق محفوظة`,
      author: "م.مشاري دعجم",
      portfolio: "مشروع بورتفوليو",
    },
  };

  const t = content[language];

  const socials = [
    { icon: "whatsapp", url: "https://wa.me/966560308877" },
    { icon: "twitter", url: "https://twitter.com/sparkleslandry01" },
    { icon: "instagram", url: "https://www.instagram.com/sparkles.landry/" },
  ];

  return (
    <footer className={`footer ${language === "ar" ? "rtl" : ""}`}>
      <div className="footer-container">
        {/* Main Grid */}
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <img src={require("../Images/Icon.jpeg")} alt={t.company} className="footer-logo" />
            <h3>{t.company}</h3>
            <p>{t.tagline}</p>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>{t.services}</h4>
            <ul>
              {t.servicesList.map((s, i) => (
                <li key={i}>
                  <a href="#services">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>{t.contact}</h4>
            <ul className="contact-list">
              <li>
                <i className="fas fa-map-marker-alt" />
                <span>{t.address}</span>
              </li>
              <li>
                <i className="fas fa-envelope" />
                <a href={`mailto:${t.email}`}>{t.email}</a>
              </li>
              <li>
                <i className="fas fa-phone" />
                <a href={`tel:${t.phone}`}>{t.phone}</a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="footer-col">
            <h4>{t.social}</h4>
            <div className="social-links">
              {socials.map((s, i) => (
                <motion.a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <i className={`fab fa-${s.icon}`} />
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <span className="portfolio-badge">{t.portfolio}</span>
          <p>
            {t.copyright} · 
            <button onClick={openModal} className="author-btn">
              {t.author}
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
